import { MailLogPage } from "../../../model/mail/MailLogPage/MailLogPage";

export const FN71S01MailLogSearch = () => {
  return <MailLogPage type={"root"} />;
};
